import React from "react";

export default function About({ data }) {
  if (!data) return null;
  return (
    <section id="about" className="section">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">{data.eyebrow}</span>
          <h2 className="display-2">{data.title}</h2>
        </div>

        <div className="about-grid">
          <div className="about-body">
            {data.body.map((p, i) => <p key={i}>{p}</p>)}
          </div>

          <div className="pillars">
            {data.pillars.map((p, i) => (
              <div key={i} className="pillar">
                <div className="pillar-marker">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div>
                  <div className="pillar-label">{p.label}</div>
                  <div className="pillar-text">{p.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
